import $ from 'static/script/libs/jquery';
import { component } from 'flightjs';
import FeatureFeedback from 'static/script/app/ui/feature-feedback/feature-feedback';

function FeatureFeedbackLink() {
    this.defaultAttrs({
        link: '[data-feature-feedback-link]',
        key: 'data-feature-feedback-key',
        title: 'data-feature-feedback-title',
        subtitle: 'data-feature-feedback-subtitle',
        likeLabel: 'data-feature-feedback-likelabel',
        dislikeLabel: 'data-feature-feedback-dislikeLabel',
        FeatureFeedback: '[data-feature-feedback]',
        template: '[data-feature-feedback-template]',
        offsetLeft: 'data-feature-feedback-offset-left',
        container: '[data-feature-feedback-link-container]', // Just to see how many clicks the container instead of the link
        initData: null
    });

    /*jshint maxcomplexity:7 */
    this._promptFeatureFeedback = function(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        let el = $(evt.target);
        let paddingLeft = 10;
        let top = el.height() + el.offset().top;
        let offsetLeft = parseInt(el.attr(this.attr.offsetLeft) || '0');
        let left = el.offset().left - paddingLeft + offsetLeft;
        let cssClass = el.attr('data-feature-feedback-cssclass') || '';

        let payload = {
            key: el.attr(this.attr.key),
            subtitle: el.attr(this.attr.subtitle) || '',
            title: el.attr(this.attr.title) || '',
            likeLabel: el.attr(this.attr.likeLabel) || '',
            dislikeLabel: el.attr(this.attr.dislikeLabel) || '',
            position: {
                top: top,
                left: left
            },
            cssClass: cssClass
        };

        this._initTemplateOnce();
        this.trigger(document, 'ui:feature-feedback:prompt', payload);

        let gaData = {
            category: 'Feature feedback',
            action: 'Click',
            label: 'Link'
        };
        this._trackGAEvent(gaData);
    };

    this._initTemplateOnce = function() {
        if (this.select('FeatureFeedback').length < 1) {
            let tpl = $(this.select('template').html());
            $('body').append(tpl);
            FeatureFeedback.attachTo(this.attr.FeatureFeedback);
        }
    };

    this._teardown = function() {
        this.select('FeatureFeedback').remove();
    };

    this._containerClicked = function() {
        let gaData = {
            category: 'Feature feedback',
            action: 'Click',
            label: 'Container'
        };
        this._trackGAEvent(gaData);
    };

    this._trackGAEvent = function(data) {
        this.trigger(document, 'analytics:track-event', {
            category: data.category,
            action: data.action,
            label: data.label + ' | ' + this._getPageNameForGA()
        });
    };

    this._getPageNameForGA = function() {
        return this.attr.initData.pageName || 'Unknown page';
    };

    this.after('initialize', function() {
        this.on('click', {
            link: this._promptFeatureFeedback,
            container: this._containerClicked
        });
        this.on('ui:teardown', this._teardown);
    });
}

export default component(FeatureFeedbackLink);
